import { defineMessages } from 'react-intl';

export default defineMessages({
	current_password: {
		id: 'profile.form.current_password',
		defaultMessage: "Current Password",
	},
	new_password: {
		id: 'profile.form.new_password',
		defaultMessage: "New Password",
	},
	confirm_password: {
		id: 'profile.form.confirm_password',
		defaultMessage: "Confirm Password",
	},
	password_updated: {
		id: 'profile.form.password_updated',
		defaultMessage: "Updated",
	},
	household_income: {
		id: 'profile.form.household_income',
		defaultMessage: "Household Income",
	},
	education: {
		id: 'profile.form.education',
		defaultMessage: "Education",
	},
	ethnicity: {
		id: 'profile.form.ethnicity',
		defaultMessage: "Ethnicity",
	},
	info_updated: {
		id: 'profile.form.info_updated',
		defaultMessage: "Updated",
	},
	email_activity: {
		id: 'profile.form.email_activity',
		defaultMessage: "Email me when new activities are available",
	},
	email_updates: {
		id: 'profile.form.email_updates',
		defaultMessage: "Email me with weekly updates",
	},
	error_passwords_missing: {
		id: 'profile.form.error.passwords.missing',
		defaultMessage: "Please enter passwords",
	},
	error_passwords_confirm: {
		id: 'profile.form.error.passwords.confirm',
		defaultMessage: "Confirm/New Passwords do not match",
	},
	profile_error_loading_user: {
		id: 'profile.error.user.loading',
		defaultMessage: "Loading user data failed",
	},
	profile_error_updating_user: {
		id: 'profile.error.user.updating',
		defaultMessage: "Updating user data failed",
	},
	profile_error_updating_password: {
		id: 'profile.error.password.updating',
		defaultMessage: "Updating password failed",
	},
	profile_error_invalid_password: {
		id: 'profile.error.password.invalid',
		defaultMessage: "Invalid password",
	},
});



// WEBPACK FOOTER //
// ./src/locales/profile.js